import { Link, useRouterState } from '@tanstack/react-router';
import { BookOpen, Headphones, User } from 'lucide-react';

import { cn } from '@/shared/utils';

const supportFormUrl =
  'https://form.asana.com/?k=EpJjfMiw0u_-ACOLLjKcwg&d=1205454239671179';

export const MobileTabNavigation = () => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  const coursesActive =
    pathname.startsWith('/courses') || pathname.startsWith('/plyer');
  const profileActive =
    pathname.startsWith('/profile') || pathname.startsWith('/certificates');

  const linkClass = (isActive: boolean) =>
    cn(
      'flex flex-col items-center gap-1 text-xs font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white',
      isActive ? 'text-[#4763E4]' : 'text-slate-500 hover:text-slate-600',
    );

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200/70 bg-white/90 px-10 py-3 shadow-[0_-12px_30px_rgba(15,23,42,0.12)] backdrop-blur">
      <ul className="mx-auto flex w-full max-w-md items-center justify-between">
        <li>
          <Link to={'/courses' as const} className={linkClass(coursesActive)}>
            <BookOpen className="h-6 w-6" />
            Course
          </Link>
        </li>
        <li>
          <Link to={'/profile' as const} className={linkClass(profileActive)}>
            <User className="h-6 w-6" />
            Account
          </Link>
        </li>
        <li>
          <button
            type="button"
            onClick={() => {
              window.open(supportFormUrl, '_blank', 'noopener,noreferrer');
            }}
            className={linkClass(false)}
          >
            <Headphones className="h-6 w-6" />
            Support
          </button>
        </li>
      </ul>
    </nav>
  );
};
